import { GetPdpPageContentQuery } from 'graphql/pdp/GetPdpPageContent.generated';

export enum PdpTabsKey {
  Orl = 'pdp-orl',
  Description = 'pdp-description',
  Rating = 'pdp-rating',
  Map = 'pdp-map',
  Resort = 'pdp-resort',
  Region = 'pdp-region',
  Climate = 'pdp-climate',
  Itinerary = 'pdp-itinerary',
}

export interface IPdpPageProps {
  id: string;
  content: GetPdpPageContentQuery['pdp'];
  isRoundtrip?: boolean;
}
